import { Box, Button, CircularProgress, InputLabel, TextField, Typography } from '@mui/material';
import { Colors } from '@vabembarqueja/embarque-ja-shared-components';
import { useRef, useState } from 'react';

import InputError from 'src/app/components/Form/InputError';
import { ConfirmarTokenPosPago } from 'src/models/LinkPagamento';
import LinkPagamentoService from 'src/services/LinkPagamento.service';

export interface ConfirmacaoPosPagoProps {
  idSolicitacaoLink: string;
  onError: (error: string) => void;
  onSucess: () => void;
}

export function ConfirmacaoPosPago({
  onError,
  onSucess,
  idSolicitacaoLink
}: ConfirmacaoPosPagoProps) {
  const ref = useRef<HTMLInputElement>(null);
  const [errorMsg, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleConfirm = () => {
    if (!ref.current?.value || ref.current?.value.length < 5) {
      setError('Token inválido');
      return;
    }
    setLoading(true);
    setError('');

    const confirmacaoData: ConfirmarTokenPosPago = {
      idSolicitacaoLink,
      token: ref.current.value.toUpperCase()
    };

    LinkPagamentoService.confirmarTokenPosPago(confirmacaoData)

      .then(onSucess)
      .catch((err) => onError(err.message))
      .finally(() => setLoading(false));
  };
  return (
    <>
      <InputLabel>Token de confirmação</InputLabel>
      <TextField
        inputRef={ref}
        fullWidth
        sx={{ marginTop: 1 }}
        placeholder="Digite o token de confirmação"
        color={errorMsg ? 'error' : 'primary'}
      />
      <InputError error={errorMsg}></InputError>
      {loading ? (
        <Box
          display="flex"
          justifyContent="center"
          mt={2}
          padding={1}
          borderRadius={1}
          sx={{ border: `1px solid ${Colors.primary.dark}` }}
        >
          <CircularProgress size={25} />
        </Box>
      ) : (
        <Button
          sx={{ marginTop: 1 }}
          fullWidth
          variant="contained"
          onClick={handleConfirm}
          disabled={loading}
        >
          <Typography textTransform="none">Confirmar</Typography>
        </Button>
      )}
    </>
  );
}
